import { render, staticRenderFns } from "./payStatus.vue?vue&type=template&id=f2af5f08&scoped=true"
import script from "./payStatus.vue?vue&type=script&lang=js"
export * from "./payStatus.vue?vue&type=script&lang=js"
import style0 from "./payStatus.vue?vue&type=style&index=0&id=f2af5f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2af5f08",
  null
  
)

export default component.exports